import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import ElementContainer from './ElementContainer';

const styles = {
    fontSize: '14px',
    display: 'inline-block',
    color: '#999',
    lineHeight: '20px',
    textAlign: 'left',
};

export default function DialogLowerSectionText(props) {
    return (
        <ElementContainer>
            <span style={styles}>
                {props.children}
            </span>
        </ElementContainer>
    );
}

DialogLowerSectionText.displayName = displayName('Dialog/LowerSectionFormText');

DialogLowerSectionText.propTypes = {
    children: PropTypes.any.isRequired,
};
